// Module
var code = "<jp-loading size=\"xs\" ng-if=\"!$ctrl.loaded\"></jp-loading><img height=\"60\" ng-src=\"{{$ctrl.url}}\" ng-if=\"$ctrl.loaded\"/>";
// Exports
var _module_exports =code;;
var path = '/ng-templates/src/commons/components/kp-lazy-load-img/kp-lazy-load-img.tpl.pug';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;